// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__tgQpO","toggleItemOne":"Toggle_toggleItemOne__GeNaT","toggleItemTwo":"Toggle_toggleItemTwo__0Dc-o"};